<template>
  <div class="image-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="数据源" name="1">
        <div>
          <div class="data-source-type">
            <cx-slider :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
          </div>
          <div v-show="pageType !== 'detailPage' && noCacheComponent">
            <!-- <div class="dataSource-item mt12" @click="goToChooseData">
              <span>进入数据管理后台 </span>
            </div> -->
            <data-center-choose 
              :checkStatus="checkStatus"
              :myId="ids"
              :options="options"
              class="mt12"
              @onDataCenterChange="onDataCenterChange"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="pageType !== 'pageType' && pageType !== 'listPage' && noCacheComponent || (showColsFieldMapping && layoutOptions.noCacheComponent)"
        title="绑定数据"
        name="2"
      >
        <div class="content">
          <div v-if="noCacheComponent" :class="currentFiledMappingChecked && currentFieldMappingFieldFlag ? 'mapping_content checked' : 'mapping_content'">
            <div class="content-title">
              {{ getValueByTypeHandle(options.innerElement) }}
            </div>
            <div class="select_content mt8">
              <el-select
                style="width: 100%"
                v-model="currentFieldMappingFieldFlag"
                placeholder="请选择"
                clearable
              >
                <el-option v-for="(item, index) in currentFieldMappingList" :key="index" :label="item.label" :value="item.value">
                  <span style="font-size: 13px">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="verticallyCenter mapping_date_content mt8">
              <label class="date-label">显示为:</label>
              <el-dropdown trigger="click" @command="onChangeMappingType">
                <span class="el-dropdown-link">
                  {{ fieldMappingDataType }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown">
                  <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
                    <div :class="currentFieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                      {{ item.label }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <colsFieldMappingSetting :ids="ids" :options="options" v-if="showColsFieldMapping && !noCacheComponent"></colsFieldMappingSetting>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="pageType === 'detailPage' && noCacheComponent"
        title="绑定数据"
        name="2"
      >
        <detailPageFieldMappingSetting :myid="ids" :options="options"></detailPageFieldMappingSetting>
      </el-collapse-item>
      <el-collapse-item
        title="链接地址"
        name="3"
        v-if="!noCacheComponent && !noCacheComponentLayout"
      >
        <div class="content">
          <div>
            <div class="content-item verticallyCenter clearFloat">
              <el-radio-group v-model="linkAddressVal">
                <el-radio label="默认">当前网页</el-radio>
                <el-radio label="自定义">自定义</el-radio>
              </el-radio-group>
            </div>
            <div v-if="linkAddressVal == '自定义'" class="content-item verticallyCenter mt16">
              <el-input style="width: 100%" v-model="linkUrlVal" placeholder="请输入二维码值"></el-input>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-show="pageType !== 'detailPage' && noCacheComponent" title="更多" name="4">
        <div>
          <auto-update-timer />
          <div class="mt12">
            <!-- <div class="getDataBtn mb12" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
            <cx-check-box v-if="request_prefix==='bigScreen'" :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import detailPageFieldMappingSetting from "publicSetting/detailPageFieldMappingSetting.vue"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import { getValueByType, isExist } from "utils"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  name: "code-options-data",
  components: { detailPageFieldMappingSetting, autoUpdateTimer, colsFieldMappingSetting, dataCenterChoose },
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      currentFieldMappingList: [],
      dataTypeList: [
        {
          label: "字段内容",
          value: "dataValue"
        }
      ]
    }
  },
  watch: {
    currentFiledMapping: {
      deep: true,
      handler(n, o) {
        if (n && n.isChecked) {
          if (this.currentFieldMappingList.length > 0) {
            this.currentFieldMappingList.forEach((item, index) => {
              if (item.value === n.fieldFlag) {
                switch (n.dataType) {
                  case "dataKey":
                    this.linkUrlVal = item.label + "：" + item.content
                    break
                  case "dataValue":
                    this.linkUrlVal = item.content
                    break
                  case "dataName":
                    this.linkUrlVal = item.label
                    break
                }
              }
            })
          }
        }
      }
    }
  },
  computed: {
    linkAddressVal: {
      get() {
        return this.options.linkAddressVal || "默认"
      },
      set(newVal) {
        const { pageId } = this.$store.state.states.getDataPageIds
        if (newVal === "默认") {
          let url = window.location.protocol + "//" + window.location.host + `/v2/p/${pageId}`
          this.linkUrlVal = url
        }
        this.$changeOptionsEV(newVal, "linkAddressVal", false)
      }
    },
    linkUrlVal: {
      get() {
        return this.options.linkUrlVal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkUrlVal", false)
      }
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    ids() {
      return this.$store.state.states.activeID
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
        // 如果在详情页中文本组件选中外接数据源，需要先初始化文本组件在详情页的相关对象属性detailFieldMapping，同时给文本组件增加在详情页中请求数据源的插件
        if (this.pageType === "detailPage" && newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataKey",
              fieldFlag: ""
            },
            "detailFieldMapping",
            false,
            false,
            false,
            true
          )
        }
        if (this.pageType !== "detailPage" && this.pageType !== "listPage" && newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataValue",
              fieldFlag: ""
            },
            "currentFiledMapping",
            false,
            false,
            false,
            true
          )
        }
      }
    },
    showColsFieldMapping() {
      return this.ids?.uid || isExist(this.ids?.elementInSwiperId)
    },
    noCacheComponentLayout() {
      // 在四边栏中 不控制
      if (!this.showColsFieldMapping) return false
      // 在中间内容区
      const rectAttr = this.layoutOptions
      let filedMapping = this.options && this.options.filedMapping && this.options.filedMapping.flag
      if (rectAttr && rectAttr.innerElement !== "emptyLayoutComponent" && rectAttr.innerElement !== "swiperComponent") return false
      else return filedMapping && rectAttr && rectAttr.noCacheComponent
    },

    layoutOptions() {
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids, "rect")?.options
      if (rectAttr && isExist(this.ids.elementInAutoLayoutId) && (isExist(this.ids.elementInLayoutId) || isExist(this.ids.elementInSwiperId)) && rectAttr.innerElement === "cxAutoLayout") {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], { ...this.ids, elementInLayoutId: undefined })
      }
      if (rectAttr && rectAttr.innerElement !== "emptyLayoutComponent" && rectAttr.innerElement !== "swiperComponent" || !rectAttr.noCacheComponent) return {}
      return rectAttr
    },
    currentFiledMapping: {
      get() {
        return this.options.currentFiledMapping
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping", false)
      }
    },
    currentFiledMappingChecked: {
      get() {
        return this.options.currentFiledMapping?.isChecked || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.isChecked", false)
      }
    },
    currentFieldMappingFieldFlag: {
      get() {
        return this.options.currentFiledMapping?.fieldFlag
      },
      set(newVal) {
        this.$changeOptionsEV([newVal, !!newVal], ["currentFiledMapping.fieldFlag", "currentFiledMapping.isChecked"], false)
      }
    },
    currentFieldMappingDataType: {
      get() {
        return this.currentFiledMapping && this.currentFiledMapping.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.dataType", false, null, {
          ...this.ids
        })
      }
    },
    dataOptions() {
      const options = [{ value: false, title: "本地数据" }]
      if (this.pageType === "detailPage" || this.pageType === "listPage" || this.showColsFieldMapping) {
        options.push({ value: true, title: "数据绑定" })
      } else {
        options.push({ value: true, title: "数据中心" })
      }
      return options
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
    },
    fieldMappingDataType() {
      const item = this.dataTypeList.find(data => data.value === this.currentFieldMappingDataType)
      return item?.label || ""
    },
  },
  mounted() {
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  methods: {
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid, homePageId, pageType } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!!!moduleId || !!!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (!!res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(this, datas => {
          this.linkUrlVal = datas[0][Object.keys(datas[0])[0]].value
          // type: 是否要重新加入字段匹配下拉项 避免点击数据响应就加一次
          if (datas) {
            this.currentFieldMappingList = []
            Object.keys(datas[0]).forEach((key, index) => {
              if (key === "content") return
              if (key && datas[0][key]?.value) {
                const temp = {
                  value: key,
                  label: datas[0][key].key,
                  content: datas[0][key].value
                }
                this.currentFieldMappingList.push(temp)
              }
            })
          }
        })
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    onChangeMappingType(value) {
      this.currentFieldMappingDataType = value
    },
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}

.getDataBtn:hover {
  cursor: pointer;
}

.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
.bigScreen {
  .mapping_content {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    background-color: rgba(40, 42, 46, 1);
    &.checked,
    &:hover {
      border-color: rgba(166, 139, 255, 0.16);
      background-color: rgba(166, 139, 255, 0.04);
    }
    .select_content {
      ::v-deep .el-input__inner {
        background-color: rgba(31, 33, 36, 1);
        box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset;
      }
    }
    &.checked {
      .select_content {
        ::v-deep .el-input__inner {
          background-color: rgba(166, 139, 255, 0.1);
          color: rgba(166, 139, 255, 1);
          box-shadow: 0px 0px 0px 1px rgba(166, 139, 255, 0.16) inset;
          &:hover {
            background-color: rgba(166, 139, 255, 0.2);
          }
        }
        ::v-deep .el-select__caret {
          color: rgba(166, 139, 255, 1);
        }
        ::v-deep .is-focus .el-input__inner {
          background-color: rgba(166, 139, 255, 0.2);
        }
      }
    }
  }
}
.custom-dropdown.bigScreen {
  .dropdown-title-show {
    border-color: rgba(55, 55, 55, 1);
  }
  ::v-deep .el-dropdown-menu__item {
    color: rgba(255, 255, 255, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
</style>
